export default __webpack_public_path__ + "static/media/Royal Atlantean Dagger.6d696540.jpg";